import { useMemo } from 'react';
import _ from 'lodash';

import { useInvestor } from '@/modules/investments/hooks';
import { useActiveFunds } from '@/modules/investments/Investments/hooks';
import { FundPayload } from '@/modules/investments/SelfDirected/SelfDirected.types';
interface Params {
  accountId?: string;
}
export default ({ accountId }: Params) => {
  const { data: activeFunds } = useActiveFunds({
    accountId,
  });

  const {
    data: { fullLiquidationIds },
  } = useInvestor(accountId);

  const formattedData = useMemo(() => {
    return activeFunds?.map((item) => {
      const fund: FundPayload = {
        ...item,
        isFullLiquidation: fullLiquidationIds.includes(_.toNumber(item.id)) || false,
      };
      return fund;
    });
  }, [activeFunds, fullLiquidationIds]);
  return {
    data: formattedData,
  };
};
